import branchManagementCustomerPickupReportsComponent from './customer_pickup_reports.component';
import PrintModule from './print';

let branchManagementCustomerPickupReportsModule = angular.module('branchManagementCustomerPickupReports', [PrintModule])
    .component('branchManagementCustomerPickupReports', branchManagementCustomerPickupReportsComponent)
    .name;

export default branchManagementCustomerPickupReportsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/index.js